import {
  TIMER_DROP_DOWN,
  TIMER_DROP_DOWN_SUCCESS,
  TIMER_DROP_DOWN_FAILURE,
} from "./actionType";

const initialState = {
  loading: false,
  timer_drop_down: false,
};

const dropDownReducer = (state = initialState, action) => {
  switch (action.type) {
    case TIMER_DROP_DOWN:
      return {
        ...state,
        loading: true,
        timer_drop_down: action.payload,
      };
    case TIMER_DROP_DOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        timer_drop_down: action.payload,
      };
    case TIMER_DROP_DOWN_FAILURE:
      return {
        ...state,
        loading: false,
        timer_drop_down: false,
      };
    default:
      return state;
  }
};

export default dropDownReducer;
